import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";
import { Button } from "@folio/stripes/components";
export var useOnixCodetablesTable = function () {
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.onix-codetables.table.columns.number",
            }),
            key: "number",
            clickable: true,
            onClick: function (row) {
                if (!(row === null || row === void 0 ? void 0 : row.id))
                    return;
                history.push("/bragency/onix-codetables/edit/".concat(encodeURIComponent(row.id)));
            },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.onix-codetables.table.columns.name",
            }),
            key: "name",
        },
        {
            name: formatMessage({
                id: "ui-br-agency.onix-codetables.table.columns.items",
            }),
            key: "items",
            cellRenderer: function (row) { return (React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, onClick: function () {
                    return (row === null || row === void 0 ? void 0 : row.id) &&
                        history.push("/bragency/onix-codetable-items?onixCodetableId=".concat(encodeURIComponent(row.id)));
                } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.onix-codetables.table.columns.items" }))); },
        },
    ]; }, [formatMessage, history]);
    return { columns: columns };
};
